import { render, staticRenderFns } from "./CheckListItemDetailText.vue?vue&type=template&id=86c6107e&scoped=true&"
import script from "./CheckListItemDetailText.vue?vue&type=script&lang=js&"
export * from "./CheckListItemDetailText.vue?vue&type=script&lang=js&"
import style0 from "./CheckListItemDetailText.vue?vue&type=style&index=0&id=86c6107e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c6107e",
  null
  
)

export default component.exports